import { produce } from 'immer';

import { ResetInternalBannerImageUploadError } from '../../../actions/imageEditor/internal/resetInternalBannerImageUploadError';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { ImageOrCreativeUploadingMode } from '../../../typings/banners';
import { ImageEditorsState } from '../../../typings/state';

export function resetInternalBannerImageUploadError(
    state: ImageEditorsState,
    action: ResetInternalBannerImageUploadError
): ImageEditorsState {
    const { EMPTY } = ImageOrCreativeUploadingMode;
    const id = getImageEditorIdByBannerId(action.bannerId, action.resourceId);

    return produce(state, draft => {
        if (!draft[id].image.isUploadByLink) {
            draft[id].image.mode = EMPTY;
        }

        const data = draft[id].image.data;

        if (data) {
            draft[id].image.mode = ImageOrCreativeUploadingMode.UPLOADED;
            draft[id].image.displayName = data.name;
        }

        draft[id].image.errors = undefined;
    });
}
